export const COMPANY_CLASSIFICATION_FIELDS = [
  "industry",
  "subsector",
  "companyType",
  "category",
  "typeTags",
] as const;

export type CompanyClassificationField = (typeof COMPANY_CLASSIFICATION_FIELDS)[number];

export interface CompanyClassificationGuidance {
  label: string;
  description: string;
  examples: readonly string[];
  cardinality: "single" | "multiple";
}

/**
 * Vocabolario descrittivo condiviso da frontend, backend e future istruzioni ExAi.
 * Le etichette tradotte non cambiano il significato canonico del campo.
 */
export const COMPANY_CLASSIFICATION_GUIDANCE: Record<
  CompanyClassificationField,
  CompanyClassificationGuidance
> = {
  industry: {
    label: "Settore",
    description: "Macrosettore economico principale dell'azienda. Inserisci un solo valore stabile e adatto alla reportistica.",
    examples: ["Retail / Commercio", "Servizi finanziari", "Immobiliare", "Tecnologia"],
    cardinality: "single",
  },
  subsector: {
    label: "Sottosettore",
    description: "Ambiti di attività nei quali opera concretamente l'azienda. Un'azienda può appartenere a più sottosettori.",
    examples: ["Ristorazione", "Moda e abbigliamento", "Beauty e cura della persona", "Bancario"],
    cardinality: "multiple",
  },
  companyType: {
    label: "Tipo azienda",
    description: "Modello organizzativo o ruolo operativo prevalente dell'azienda, non il prodotto che vende.",
    examples: ["Franchisee", "Franchisor", "Multi-unit operator", "Gruppo bancario integrato"],
    cardinality: "single",
  },
  category: {
    label: "Categoria",
    description: "Famiglie di offerta o attività utilizzate per segmentazione, mailing list, opportunità e analisi.",
    examples: ["Fast food", "Yogurteria", "Retail banking", "Asset management"],
    cardinality: "multiple",
  },
  typeTags: {
    label: "Tag tipologia",
    description: "Caratteristiche granulari e ricercabili dell'offerta. Non duplicare settore, sottosettore o tipo azienda.",
    examples: ["Burger", "Yogurt", "Hair care", "Mutui"],
    cardinality: "multiple",
  },
};
